import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDUltrarouletteDetailResult implements ICommand
{

	public ResultString : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.ResultString = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeString(this.ResultString);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDUltrarouletteDetailResult();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'ResultString(S)='+this.ResultString+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'UltrarouletteDetailResult';
	}

}
